<template>
	<div
		class="fixed inset-0 overflow-y-scroll bg-black bg-opacity-50 z-20"
		style="backdrop-filter: blur(5px); overscroll-behavior: contain"
	>
		<div class="flex items-start justify-center text-center my-24">
			<div
				class="bg-white rounded-lg text-center shadow-xl w-3/5 md:w-3/5 lg:w-3/5 xl:w-3/5 xxl:w-3/5 2xl:w-3/5 justify-center relative"
				style="min-height: 400px"
				role="dialog"
				aria-modal="true"
			>
				<div>
					<div>
						<div v-if="!isLoading" class="py-2">
							<BaseHeader class="rounded-t-lg" title="Hilfecenter" :subtitle="$t('question_or_problem_send_message').toString()">
								<font-awesome-icon :icon="['fas', 'times']" class="cursor-pointer text-xl" @click="closeModal" />
							</BaseHeader>
							<div class="px-10 py-4">
								<div class="w-full flex justify-start">
									<div class="flex flex-col w-full">
										<BaseInput :required="true" ref="helpMessage" v-model="message" :label="$t('explain_issue').toString()">
											<textarea
												class="resize-y w-full shadow-m h-32"
												:required="true"
												ref="message"
												@change="setConfirmLeaving"
												v-model="message"
												:disabled="false"
											></textarea>
										</BaseInput>
										<div>
											<BaseCheckbox class="mt-4" :label="$t('prefer_contact_via_video_call')" v-model="videoCallPreferred" />
										</div>
									</div>
								</div>
								<Footer :is-back-button="false" :is-continue-button="true">
									<template #continueButton>
										<SaveButton @click="save">{{ $t('forward') }}</SaveButton>
									</template>
								</Footer>
							</div>
						</div>
						<LoadingSpinner class="pt-2" v-else />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Validate from '@/mixins/Validate';
import Authentication from '@/mixins/Authentication';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox.vue';
import HelpContactRepository from '@/api/repositories/HelpContactRepository';
import BaseHeader from '@/components/navigation/BaseHeader.vue';
import Footer from '@/components/damagecases/Footer.vue';
import SaveButton from '@/components/forms/buttons/SaveButton.vue';

export default {
	name: 'HelpContact',
	components: { SaveButton, Footer, BaseHeader, BaseCheckbox, BaseInput, LoadingSpinner },
	mixins: [Validate, Authentication],
	data() {
		return {
			message: '',
			videoCallPreferred: false,
			isLoading: false,
		};
	},
	methods: {
		setConfirmLeaving() {
			if (this.message !== '') {
				this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
			} else {
				this.$store.commit('setConfirmLeaving', false);
			}
		},
		closeModal() {
			this.$store.commit('setIsShowHelpModal', false);
		},
		async save() {
			try {
				if (this.validate()) {
					this.isLoading = true;
					new HelpContactRepository()
						.sendMessage(this.message, this.videoCallPreferred)
						.then(response => {
							this.isLoading = false;
							this.$store.commit('setConfirmLeaving', false);
							this.$swal(this.$t('general.success'), this.$t('message_sent_admin_will_contact'), 'success').then(_ => {
								this.$store.commit('setIsShowHelpModal', false);
							});
						})
						.catch(e => {
							console.log(e);
							this.isLoading = false;
							this.$swal(this.$t('general.error'), this.$t('message_sent_error'), 'error');
						});
				} else {
					await this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				}
			} catch (e) {
				this.isLoading = false;
				await this.$swal(this.$t('general.error'), this.$t('message_sent_error'), 'error');
			}
		},
	},
	mounted() {
		window.document.documentElement.classList.add('disableScroll');
	},
	beforeDestroy() {
		window.document.documentElement.classList.remove('disableScroll');
	},
};
</script>

<style scoped></style>
